import { put, take } from 'redux-saga/effects';

import { EXIT_SNIPPET } from './actions';
import { RESET_READER } from 'Reducers/compModels';
import { notifications, SET_ISLOADING } from 'PipeRouter';


function* exitSnippet() {
  while (true) {
    yield take(EXIT_SNIPPET);

    yield put(notifications(SET_ISLOADING, true));
    yield put({ type: RESET_READER });

    logger.info('Exit Snippet');
    vsViewer.Snippet.exit((e, data) => {
      logger.info('Exit Snippet Response', e);
    });
  }
}


export default exitSnippet;
